(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js', './boislocal-platform-platform-infra-commons-commons-domain.js', './boislocal-platform-platform-s2-referential-organizationType-organizationType-domain.js', './boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'), require('./boislocal-platform-platform-s2-referential-organizationType-organizationType-domain.js'), require('./boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-productType-productType-domain'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'boislocal-platform-platform-s2-referential-productType-productType-domain'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-productType-productType-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-s2-referential-productType-productType-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-productType-productType-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-s2-referential-productType-productType-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-productType-productType-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-s2-referential-productType-productType-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-productType-productType-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-s2-referential-productType-productType-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-productType-productType-domain'. Its dependency 'boislocal-platform-platform-s2-referential-organizationType-organizationType-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-referential-organizationType-organizationType-domain' is loaded prior to 'boislocal-platform-platform-s2-referential-productType-productType-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-productType-productType-domain'. Its dependency 'boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain' is loaded prior to 'boislocal-platform-platform-s2-referential-productType-productType-domain'.");
    }
    root['boislocal-platform-platform-s2-referential-productType-productType-domain'] = factory(typeof this['boislocal-platform-platform-s2-referential-productType-productType-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-s2-referential-productType-productType-domain'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['fixers-f2-f2-dsl-f2-dsl-cqrs'], this['boislocal-platform-platform-infra-commons-commons-domain'], this['boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'], this['boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_komune_s2_s2_automate_dsl, kotlin_io_komune_f2_f2_dsl_cqrs, kotlin_org_boislocal_commons_domain, kotlin_org_boislocal_organizationType_domain, kotlin_org_boislocal_ouvrageType_domain) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.ge;
  var protoOf = kotlin_kotlin.$_$.fa;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var THROW_IAE = kotlin_kotlin.$_$.ld;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var Enum = kotlin_kotlin.$_$.zc;
  var defineProp = kotlin_kotlin.$_$.b9;
  var S2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.j;
  var classMeta = kotlin_kotlin.$_$.z8;
  var S2TransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.b;
  var toValue = kotlin_io_komune_s2_s2_automate_dsl.$_$.m;
  var toValue_0 = kotlin_io_komune_s2_s2_automate_dsl.$_$.n;
  var getKClass = kotlin_kotlin.$_$.f;
  var toValue_1 = kotlin_io_komune_s2_s2_automate_dsl.$_$.l;
  var S2Transition = kotlin_io_komune_s2_s2_automate_dsl.$_$.k;
  var S2SelfTransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.a;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.j5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var s2Sourcing = kotlin_io_komune_s2_s2_automate_dsl.$_$.c;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.da;
  var S2Role = kotlin_io_komune_s2_s2_automate_dsl.$_$.i;
  var S2InitCommand = kotlin_io_komune_s2_s2_automate_dsl.$_$.h;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var WithS2Id = kotlin_io_komune_s2_s2_automate_dsl.$_$.e;
  var Event = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.d;
  var $serializer_init_$Create$ = kotlin_org_boislocal_commons_domain.$_$.a;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var toString = kotlin_kotlin.$_$.le;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var hashCode = kotlin_kotlin.$_$.j9;
  var equals = kotlin_kotlin.$_$.c9;
  var $serializer_getInstance = kotlin_org_boislocal_organizationType_domain.$_$.b;
  var $serializer_getInstance_0 = kotlin_org_boislocal_ouvrageType_domain.$_$.a;
  var $serializer_getInstance_1 = kotlin_org_boislocal_commons_domain.$_$.g;
  var S2Command = kotlin_io_komune_s2_s2_automate_dsl.$_$.g;
  var Long = kotlin_kotlin.$_$.ed;
  var WithS2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.f;
  var Roles_instance = kotlin_org_boislocal_commons_domain.$_$.b;
  var hasRole = kotlin_org_boislocal_commons_domain.$_$.m;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var isAvailableTransition = kotlin_io_komune_s2_s2_automate_dsl.$_$.d;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor(ProductTypeState, 'ProductTypeState', classMeta, Enum, [Enum, S2State], VOID, VOID, {0: Companion_getInstance});
  setMetadataFor(S2, 'S2', objectMeta);
  setMetadataFor(UserRole, 'UserRole', classMeta, VOID, [S2Role], VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(User, 'User', objectMeta, UserRole);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductTypeCreateCommandDTO, 'ProductTypeCreateCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(ProductTypeCreatedEventDTO, 'ProductTypeCreatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductTypeCreateCommand, 'ProductTypeCreateCommand', classMeta, VOID, [ProductTypeCreateCommandDTO], VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductTypeCreatedEvent, 'ProductTypeCreatedEvent', classMeta, VOID, [ProductTypeCreatedEventDTO], VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(ProductTypeDeleteCommandDTO, 'ProductTypeDeleteCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(ProductTypeDeletedEventDTO, 'ProductTypeDeletedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductTypeDeleteCommand, 'ProductTypeDeleteCommand', classMeta, VOID, [ProductTypeDeleteCommandDTO], VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductTypeDeletedEvent, 'ProductTypeDeletedEvent', classMeta, VOID, [ProductTypeDeletedEventDTO], VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(ProductTypeImportCommandDTO, 'ProductTypeImportCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(ProductTypeImportedEventDTO, 'ProductTypeImportedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductTypeImportCommand, 'ProductTypeImportCommand', classMeta, VOID, [ProductTypeImportCommandDTO], VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductTypeImportedEvent, 'ProductTypeImportedEvent', classMeta, VOID, [ProductTypeImportedEventDTO], VOID, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(ProductTypeUpdateCommandDTO, 'ProductTypeUpdateCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(ProductTypeUpdatedEventDTO, 'ProductTypeUpdatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductTypeUpdateCommand, 'ProductTypeUpdateCommand', classMeta, VOID, [ProductTypeUpdateCommandDTO], VOID, VOID, {0: $serializer_getInstance_9});
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductTypeUpdatedEvent, 'ProductTypeUpdatedEvent', classMeta, VOID, [ProductTypeUpdatedEventDTO], VOID, VOID, {0: $serializer_getInstance_10});
  setMetadataFor(ProductTypeModelDTO, 'ProductTypeModelDTO', interfaceMeta, VOID, [WithS2State, WithS2Id]);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor($serializer_8, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductTypeModel, 'ProductTypeModel', classMeta, VOID, [ProductTypeModelDTO], VOID, VOID, {0: $serializer_getInstance_11});
  setMetadataFor(ProductTypePolicies, 'ProductTypePolicies', objectMeta);
  setMetadataFor(ProductTypeGetQueryDTO, 'ProductTypeGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(ProductTypeGetResponseDTO, 'ProductTypeGetResponseDTO', interfaceMeta);
  setMetadataFor(ProductTypePageQueryFiltersDTO, 'ProductTypePageQueryFiltersDTO', interfaceMeta);
  setMetadataFor(ProductTypePageQueryDTO, 'ProductTypePageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(ProductTypePageResponseDTO, 'ProductTypePageResponseDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.a2i_1.f2();
  }
  function ProductTypeState$Companion$_anonymous__8mydh5() {
    return createSimpleEnumSerializer('org.boislocal.platform.s2.productType.domain.automate.ProductTypeState', values());
  }
  var ProductTypeState_Exists_instance;
  var ProductTypeState_Deleted_instance;
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a2i_1 = lazy(tmp_0, ProductTypeState$Companion$_anonymous__8mydh5);
  }
  protoOf(Companion).x14 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion).hu = function (typeParamsSerializers) {
    return this.x14();
  };
  var Companion_instance;
  function Companion_getInstance() {
    ProductTypeState_initEntries();
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function values() {
    return [ProductTypeState_Exists_getInstance(), ProductTypeState_Deleted_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'Exists':
        return ProductTypeState_Exists_getInstance();
      case 'Deleted':
        return ProductTypeState_Deleted_getInstance();
      default:
        ProductTypeState_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ProductTypeState_entriesInitialized;
  function ProductTypeState_initEntries() {
    if (ProductTypeState_entriesInitialized)
      return Unit_instance;
    ProductTypeState_entriesInitialized = true;
    ProductTypeState_Exists_instance = new ProductTypeState('Exists', 0, 0);
    ProductTypeState_Deleted_instance = new ProductTypeState('Deleted', 1, 1);
    Companion_getInstance();
  }
  function ProductTypeState(name, ordinal, position) {
    Enum.call(this, name, ordinal);
    this.d2i_1 = position;
  }
  protoOf(ProductTypeState).y2c = function (_set____db54di) {
    this.d2i_1 = _set____db54di;
  };
  protoOf(ProductTypeState).jr = function () {
    return this.d2i_1;
  };
  function S2$productTypeAutomate$lambda($this$s2Sourcing) {
    $this$s2Sourcing.j27_1 = 'ProductType';
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.productType.domain.automate.S2.productTypeAutomate.<anonymous>.<anonymous>' call
    builder.o27_1 = ProductTypeState_Exists_getInstance();
    builder.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver = builder.m27_1;
    var tmp = tmp0_safe_receiver == null ? null : toValue(tmp0_safe_receiver);
    var tmp_0 = toValue(builder.c24());
    var tmp_1 = toValue_0(builder.d24());
    var tmp_2 = toValue_1(getKClass(ProductTypeImportCommand));
    var tmp1_elvis_lhs = builder.q27_1;
    var this_0 = new S2Transition(tmp, tmp_0, tmp_1, tmp_2, toValue_1(tmp1_elvis_lhs == null ? getKClass(ProductTypeImportedEvent) : tmp1_elvis_lhs));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_0);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_0 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.productType.domain.automate.S2.productTypeAutomate.<anonymous>.<anonymous>' call
    builder_0.o27_1 = ProductTypeState_Deleted_getInstance();
    builder_0.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = builder_0.m27_1;
    var tmp_3 = tmp0_safe_receiver_0 == null ? null : toValue(tmp0_safe_receiver_0);
    var tmp_4 = toValue(builder_0.c24());
    var tmp_5 = toValue_0(builder_0.d24());
    var tmp_6 = toValue_1(getKClass(ProductTypeImportCommand));
    var tmp1_elvis_lhs_0 = builder_0.q27_1;
    var this_1 = new S2Transition(tmp_3, tmp_4, tmp_5, tmp_6, toValue_1(tmp1_elvis_lhs_0 == null ? getKClass(ProductTypeImportedEvent) : tmp1_elvis_lhs_0));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_1);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_1 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.productType.domain.automate.S2.productTypeAutomate.<anonymous>.<anonymous>' call
    builder_1.o27_1 = ProductTypeState_Exists_getInstance();
    builder_1.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_1 = builder_1.m27_1;
    var tmp_7 = tmp0_safe_receiver_1 == null ? null : toValue(tmp0_safe_receiver_1);
    var tmp_8 = toValue(builder_1.c24());
    var tmp_9 = toValue_0(builder_1.d24());
    var tmp_10 = toValue_1(getKClass(ProductTypeCreateCommand));
    var tmp1_elvis_lhs_1 = builder_1.q27_1;
    var this_2 = new S2Transition(tmp_7, tmp_8, tmp_9, tmp_10, toValue_1(tmp1_elvis_lhs_1 == null ? getKClass(ProductTypeCreatedEvent) : tmp1_elvis_lhs_1));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_2);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_2 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.productType.domain.automate.S2.productTypeAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_3 = builder_2.r27_1;
    var element = ProductTypeState_Exists_getInstance();
    this_3.r(element);
    builder_2.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_4 = builder_2.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
    var tmp0_iterator = this_4.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_11 = toValue(item);
      var tmp_12 = toValue(item);
      var tmp_13 = toValue_0(builder_2.d24());
      var tmp_14 = toValue_1(getKClass(ProductTypeUpdateCommand));
      var tmp0_elvis_lhs = builder_2.t27_1;
      var tmp$ret$6 = new S2Transition(tmp_11, tmp_12, tmp_13, tmp_14, toValue_1(tmp0_elvis_lhs == null ? getKClass(ProductTypeUpdatedEvent) : tmp0_elvis_lhs));
      destination.r(tmp$ret$6);
    }
    var tmp3_forEach_receiver = $this$s2Sourcing.l27_1;
    var tmp0_iterator_0 = destination.u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.w();
      invoke$add(tmp3_forEach_receiver, element_0);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_3 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.productType.domain.automate.S2.productTypeAutomate.<anonymous>.<anonymous>' call
    builder_3.m27_1 = ProductTypeState_Exists_getInstance();
    builder_3.o27_1 = ProductTypeState_Deleted_getInstance();
    builder_3.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_2 = builder_3.m27_1;
    var tmp_15 = tmp0_safe_receiver_2 == null ? null : toValue(tmp0_safe_receiver_2);
    var tmp_16 = toValue(builder_3.c24());
    var tmp_17 = toValue_0(builder_3.d24());
    var tmp_18 = toValue_1(getKClass(ProductTypeDeleteCommand));
    var tmp1_elvis_lhs_2 = builder_3.q27_1;
    var this_5 = new S2Transition(tmp_15, tmp_16, tmp_17, tmp_18, toValue_1(tmp1_elvis_lhs_2 == null ? getKClass(ProductTypeDeletedEvent) : tmp1_elvis_lhs_2));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_5);
    return Unit_instance;
  }
  function invoke$add(receiver, p0) {
    receiver.r(p0);
  }
  function S2() {
    S2_instance = this;
    var tmp = this;
    tmp.e2i_1 = s2Sourcing(S2$productTypeAutomate$lambda);
  }
  var S2_instance;
  function S2_getInstance() {
    if (S2_instance == null)
      new S2();
    return S2_instance;
  }
  function User() {
    User_instance = this;
    UserRole.call(this, 'User');
  }
  var User_instance;
  function User_getInstance() {
    if (User_instance == null)
      new User();
    return User_instance;
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.productType.domain.automate.UserRole', this, 1);
    tmp0_serialDesc.ht('name', false);
    this.g2i_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.g2i_1;
  };
  protoOf($serializer).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.g2i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return UserRole_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer).h2i = function (encoder, value) {
    var tmp0_desc = this.g2i_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.h9());
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.h2i(encoder, value instanceof UserRole ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance_2() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function UserRole_init_$Init$(seen1, name, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_2().g2i_1);
    }
    $this.f2i_1 = name;
    return $this;
  }
  function UserRole_init_$Create$(seen1, name, serializationConstructorMarker) {
    return UserRole_init_$Init$(seen1, name, serializationConstructorMarker, objectCreate(protoOf(UserRole)));
  }
  function UserRole(name) {
    this.f2i_1 = name;
  }
  protoOf(UserRole).h9 = function () {
    return this.f2i_1;
  };
  protoOf(UserRole).toString = function () {
    return this.h9();
  };
  function ProductTypeState_Exists_getInstance() {
    ProductTypeState_initEntries();
    return ProductTypeState_Exists_instance;
  }
  function ProductTypeState_Deleted_getInstance() {
    ProductTypeState_initEntries();
    return ProductTypeState_Deleted_instance;
  }
  function ProductTypeCreateCommandDTO() {
  }
  function ProductTypeCreatedEventDTO() {
  }
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k2i_1 = [null, null, new ArrayListSerializer($serializer_init_$Create$(StringSerializer_getInstance())), new ArrayListSerializer($serializer_init_$Create$(StringSerializer_getInstance())), null];
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.productType.domain.command.ProductTypeCreateCommand', this, 5);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('organizationTypes', false);
    tmp0_serialDesc.ht('ouvrageTypes', false);
    tmp0_serialDesc.ht('total', false);
    this.l2i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ii = function () {
    return this.l2i_1;
  };
  protoOf($serializer_0).wt = function () {
    var tmp0_cached = Companion_getInstance_1().k2i_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[2]), get_nullable(tmp0_cached[3]), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_0).ki = function (decoder) {
    var tmp0_desc = this.l2i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.ul(tmp0_desc);
    var tmp10_cached = Companion_getInstance_1().k2i_1;
    if (tmp9_input.km()) {
      tmp4_local0 = tmp9_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.im(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.im(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.im(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.im(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.vl(tmp0_desc);
    return ProductTypeCreateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_0).m2i = function (encoder, value) {
    var tmp0_desc = this.l2i_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_1().k2i_1;
    tmp1_output.jn(tmp0_desc, 0, value.n2i_1);
    tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.o2i_1);
    tmp1_output.nn(tmp0_desc, 2, tmp2_cached[2], value.p2i_1);
    tmp1_output.nn(tmp0_desc, 3, tmp2_cached[3], value.q2i_1);
    tmp1_output.nn(tmp0_desc, 4, LongSerializer_getInstance(), value.r2i_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_0).ji = function (encoder, value) {
    return this.m2i(encoder, value instanceof ProductTypeCreateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_3() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function ProductTypeCreateCommand_init_$Init$(seen1, name, img, organizationTypes, ouvrageTypes, total, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen1))) {
      throwMissingFieldException(seen1, 31, $serializer_getInstance_3().l2i_1);
    }
    $this.n2i_1 = name;
    $this.o2i_1 = img;
    $this.p2i_1 = organizationTypes;
    $this.q2i_1 = ouvrageTypes;
    $this.r2i_1 = total;
    return $this;
  }
  function ProductTypeCreateCommand_init_$Create$(seen1, name, img, organizationTypes, ouvrageTypes, total, serializationConstructorMarker) {
    return ProductTypeCreateCommand_init_$Init$(seen1, name, img, organizationTypes, ouvrageTypes, total, serializationConstructorMarker, objectCreate(protoOf(ProductTypeCreateCommand)));
  }
  function ProductTypeCreateCommand(name, img, organizationTypes, ouvrageTypes, total) {
    Companion_getInstance_1();
    this.n2i_1 = name;
    this.o2i_1 = img;
    this.p2i_1 = organizationTypes;
    this.q2i_1 = ouvrageTypes;
    this.r2i_1 = total;
  }
  protoOf(ProductTypeCreateCommand).h9 = function () {
    return this.n2i_1;
  };
  protoOf(ProductTypeCreateCommand).d2d = function () {
    return this.o2i_1;
  };
  protoOf(ProductTypeCreateCommand).i2i = function () {
    return this.p2i_1;
  };
  protoOf(ProductTypeCreateCommand).j2i = function () {
    return this.q2i_1;
  };
  protoOf(ProductTypeCreateCommand).i1z = function () {
    return this.r2i_1;
  };
  protoOf(ProductTypeCreateCommand).toString = function () {
    return 'ProductTypeCreateCommand(name=' + this.n2i_1 + ', img=' + this.o2i_1 + ', organizationTypes=' + this.p2i_1 + ', ouvrageTypes=' + this.q2i_1 + ', total=' + toString(this.r2i_1) + ')';
  };
  protoOf(ProductTypeCreateCommand).hashCode = function () {
    var result = getStringHashCode(this.n2i_1);
    result = imul(result, 31) + (this.o2i_1 == null ? 0 : getStringHashCode(this.o2i_1)) | 0;
    result = imul(result, 31) + (this.p2i_1 == null ? 0 : hashCode(this.p2i_1)) | 0;
    result = imul(result, 31) + (this.q2i_1 == null ? 0 : hashCode(this.q2i_1)) | 0;
    result = imul(result, 31) + (this.r2i_1 == null ? 0 : this.r2i_1.hashCode()) | 0;
    return result;
  };
  protoOf(ProductTypeCreateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductTypeCreateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ProductTypeCreateCommand ? other : THROW_CCE();
    if (!(this.n2i_1 === tmp0_other_with_cast.n2i_1))
      return false;
    if (!(this.o2i_1 == tmp0_other_with_cast.o2i_1))
      return false;
    if (!equals(this.p2i_1, tmp0_other_with_cast.p2i_1))
      return false;
    if (!equals(this.q2i_1, tmp0_other_with_cast.q2i_1))
      return false;
    if (!equals(this.r2i_1, tmp0_other_with_cast.r2i_1))
      return false;
    return true;
  };
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s2i_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance()), new ArrayListSerializer($serializer_getInstance_0()), null, null];
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ProductTypeCreatedEvent', this, 7);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('organizationTypes', false);
    tmp0_serialDesc.ht('ouvrageTypes', false);
    tmp0_serialDesc.ht('total', false);
    tmp0_serialDesc.ht('time', false);
    this.t2i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ii = function () {
    return this.t2i_1;
  };
  protoOf($serializer_1).wt = function () {
    var tmp0_cached = Companion_getInstance_2().s2i_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance_1()), tmp0_cached[3], tmp0_cached[4], get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_1).ki = function (decoder) {
    var tmp0_desc = this.t2i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.ul(tmp0_desc);
    var tmp12_cached = Companion_getInstance_2().s2i_1;
    if (tmp11_input.km()) {
      tmp4_local0 = tmp11_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.im(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.gm(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.gm(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.im(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.im(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.im(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.gm(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.gm(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.im(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.im(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.vl(tmp0_desc);
    return ProductTypeCreatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_1).u2i = function (encoder, value) {
    var tmp0_desc = this.t2i_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_2().s2i_1;
    tmp1_output.jn(tmp0_desc, 0, value.v2i_1);
    tmp1_output.jn(tmp0_desc, 1, value.w2i_1);
    tmp1_output.nn(tmp0_desc, 2, $serializer_getInstance_1(), value.x2i_1);
    tmp1_output.ln(tmp0_desc, 3, tmp2_cached[3], value.y2i_1);
    tmp1_output.ln(tmp0_desc, 4, tmp2_cached[4], value.z2i_1);
    tmp1_output.nn(tmp0_desc, 5, LongSerializer_getInstance(), value.a2j_1);
    tmp1_output.nn(tmp0_desc, 6, LongSerializer_getInstance(), value.b2j_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_1).ji = function (encoder, value) {
    return this.u2i(encoder, value instanceof ProductTypeCreatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_4() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function ProductTypeCreatedEvent_init_$Init$(seen1, id, name, img, organizationTypes, ouvrageTypes, total, time, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen1))) {
      throwMissingFieldException(seen1, 127, $serializer_getInstance_4().t2i_1);
    }
    $this.v2i_1 = id;
    $this.w2i_1 = name;
    $this.x2i_1 = img;
    $this.y2i_1 = organizationTypes;
    $this.z2i_1 = ouvrageTypes;
    $this.a2j_1 = total;
    $this.b2j_1 = time;
    return $this;
  }
  function ProductTypeCreatedEvent_init_$Create$(seen1, id, name, img, organizationTypes, ouvrageTypes, total, time, serializationConstructorMarker) {
    return ProductTypeCreatedEvent_init_$Init$(seen1, id, name, img, organizationTypes, ouvrageTypes, total, time, serializationConstructorMarker, objectCreate(protoOf(ProductTypeCreatedEvent)));
  }
  function ProductTypeCreatedEvent(id, name, img, organizationTypes, ouvrageTypes, total, time) {
    Companion_getInstance_2();
    this.v2i_1 = id;
    this.w2i_1 = name;
    this.x2i_1 = img;
    this.y2i_1 = organizationTypes;
    this.z2i_1 = ouvrageTypes;
    this.a2j_1 = total;
    this.b2j_1 = time;
  }
  protoOf(ProductTypeCreatedEvent).k1y = function () {
    return this.v2i_1;
  };
  protoOf(ProductTypeCreatedEvent).h9 = function () {
    return this.w2i_1;
  };
  protoOf(ProductTypeCreatedEvent).d2d = function () {
    return this.x2i_1;
  };
  protoOf(ProductTypeCreatedEvent).i2i = function () {
    return this.y2i_1;
  };
  protoOf(ProductTypeCreatedEvent).j2i = function () {
    return this.z2i_1;
  };
  protoOf(ProductTypeCreatedEvent).i1z = function () {
    return this.a2j_1;
  };
  protoOf(ProductTypeCreatedEvent).g2c = function () {
    return this.b2j_1;
  };
  protoOf(ProductTypeCreatedEvent).s2Id = function () {
    return this.v2i_1;
  };
  protoOf(ProductTypeCreatedEvent).toString = function () {
    return 'ProductTypeCreatedEvent(id=' + this.v2i_1 + ', name=' + this.w2i_1 + ', img=' + this.x2i_1 + ', organizationTypes=' + this.y2i_1 + ', ouvrageTypes=' + this.z2i_1 + ', total=' + toString(this.a2j_1) + ', time=' + toString(this.b2j_1) + ')';
  };
  protoOf(ProductTypeCreatedEvent).hashCode = function () {
    var result = getStringHashCode(this.v2i_1);
    result = imul(result, 31) + getStringHashCode(this.w2i_1) | 0;
    result = imul(result, 31) + (this.x2i_1 == null ? 0 : this.x2i_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.y2i_1) | 0;
    result = imul(result, 31) + hashCode(this.z2i_1) | 0;
    result = imul(result, 31) + (this.a2j_1 == null ? 0 : this.a2j_1.hashCode()) | 0;
    result = imul(result, 31) + (this.b2j_1 == null ? 0 : this.b2j_1.hashCode()) | 0;
    return result;
  };
  protoOf(ProductTypeCreatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductTypeCreatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ProductTypeCreatedEvent ? other : THROW_CCE();
    if (!(this.v2i_1 === tmp0_other_with_cast.v2i_1))
      return false;
    if (!(this.w2i_1 === tmp0_other_with_cast.w2i_1))
      return false;
    if (!equals(this.x2i_1, tmp0_other_with_cast.x2i_1))
      return false;
    if (!equals(this.y2i_1, tmp0_other_with_cast.y2i_1))
      return false;
    if (!equals(this.z2i_1, tmp0_other_with_cast.z2i_1))
      return false;
    if (!equals(this.a2j_1, tmp0_other_with_cast.a2j_1))
      return false;
    if (!equals(this.b2j_1, tmp0_other_with_cast.b2j_1))
      return false;
    return true;
  };
  function ProductTypeDeleteCommandDTO() {
  }
  function ProductTypeDeletedEventDTO() {
  }
  function Companion_3() {
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.productType.domain.command.ProductTypeDeleteCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.c2j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ii = function () {
    return this.c2j_1;
  };
  protoOf($serializer_2).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_2).ki = function (decoder) {
    var tmp0_desc = this.c2j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return ProductTypeDeleteCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_2).d2j = function (encoder, value) {
    var tmp0_desc = this.c2j_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.e2j_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_2).ji = function (encoder, value) {
    return this.d2j(encoder, value instanceof ProductTypeDeleteCommand ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_5() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function ProductTypeDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_5().c2j_1);
    }
    $this.e2j_1 = id;
    return $this;
  }
  function ProductTypeDeleteCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return ProductTypeDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(ProductTypeDeleteCommand)));
  }
  function ProductTypeDeleteCommand(id) {
    this.e2j_1 = id;
  }
  protoOf(ProductTypeDeleteCommand).k1y = function () {
    return this.e2j_1;
  };
  protoOf(ProductTypeDeleteCommand).toString = function () {
    return 'ProductTypeDeleteCommand(id=' + this.e2j_1 + ')';
  };
  protoOf(ProductTypeDeleteCommand).hashCode = function () {
    return getStringHashCode(this.e2j_1);
  };
  protoOf(ProductTypeDeleteCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductTypeDeleteCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ProductTypeDeleteCommand ? other : THROW_CCE();
    if (!(this.e2j_1 === tmp0_other_with_cast.e2j_1))
      return false;
    return true;
  };
  function Companion_4() {
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ProductTypeDeletedEvent', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('time', false);
    this.f2j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ii = function () {
    return this.f2j_1;
  };
  protoOf($serializer_3).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_3).ki = function (decoder) {
    var tmp0_desc = this.f2j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.im(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.im(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return ProductTypeDeletedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_3).g2j = function (encoder, value) {
    var tmp0_desc = this.f2j_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.h2j_1);
    tmp1_output.nn(tmp0_desc, 1, LongSerializer_getInstance(), value.i2j_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_3).ji = function (encoder, value) {
    return this.g2j(encoder, value instanceof ProductTypeDeletedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_6() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function ProductTypeDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_6().f2j_1);
    }
    $this.h2j_1 = id;
    $this.i2j_1 = time;
    return $this;
  }
  function ProductTypeDeletedEvent_init_$Create$(seen1, id, time, serializationConstructorMarker) {
    return ProductTypeDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, objectCreate(protoOf(ProductTypeDeletedEvent)));
  }
  function ProductTypeDeletedEvent(id, time) {
    this.h2j_1 = id;
    this.i2j_1 = time;
  }
  protoOf(ProductTypeDeletedEvent).k1y = function () {
    return this.h2j_1;
  };
  protoOf(ProductTypeDeletedEvent).g2c = function () {
    return this.i2j_1;
  };
  protoOf(ProductTypeDeletedEvent).s2Id = function () {
    return this.h2j_1;
  };
  protoOf(ProductTypeDeletedEvent).toString = function () {
    return 'ProductTypeDeletedEvent(id=' + this.h2j_1 + ', time=' + toString(this.i2j_1) + ')';
  };
  protoOf(ProductTypeDeletedEvent).hashCode = function () {
    var result = getStringHashCode(this.h2j_1);
    result = imul(result, 31) + (this.i2j_1 == null ? 0 : this.i2j_1.hashCode()) | 0;
    return result;
  };
  protoOf(ProductTypeDeletedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductTypeDeletedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ProductTypeDeletedEvent ? other : THROW_CCE();
    if (!(this.h2j_1 === tmp0_other_with_cast.h2j_1))
      return false;
    if (!equals(this.i2j_1, tmp0_other_with_cast.i2j_1))
      return false;
    return true;
  };
  function ProductTypeImportCommandDTO() {
  }
  function ProductTypeImportedEventDTO() {
  }
  function Companion_5() {
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.productType.domain.command.ProductTypeImportCommand', this, 1);
    tmp0_serialDesc.ht('item', false);
    this.j2j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ii = function () {
    return this.j2j_1;
  };
  protoOf($serializer_4).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_11()];
  };
  protoOf($serializer_4).ki = function (decoder) {
    var tmp0_desc = this.j2j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return ProductTypeImportCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_4).k2j = function (encoder, value) {
    var tmp0_desc = this.j2j_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_11(), value.l2j_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_4).ji = function (encoder, value) {
    return this.k2j(encoder, value instanceof ProductTypeImportCommand ? value : THROW_CCE());
  };
  var $serializer_instance_4;
  function $serializer_getInstance_7() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function ProductTypeImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_7().j2j_1);
    }
    $this.l2j_1 = item;
    return $this;
  }
  function ProductTypeImportCommand_init_$Create$(seen1, item, serializationConstructorMarker) {
    return ProductTypeImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, objectCreate(protoOf(ProductTypeImportCommand)));
  }
  function ProductTypeImportCommand(item) {
    this.l2j_1 = item;
  }
  protoOf(ProductTypeImportCommand).q20 = function () {
    return this.l2j_1;
  };
  protoOf(ProductTypeImportCommand).toString = function () {
    return 'ProductTypeImportCommand(item=' + this.l2j_1 + ')';
  };
  protoOf(ProductTypeImportCommand).hashCode = function () {
    return this.l2j_1.hashCode();
  };
  protoOf(ProductTypeImportCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductTypeImportCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ProductTypeImportCommand ? other : THROW_CCE();
    if (!this.l2j_1.equals(tmp0_other_with_cast.l2j_1))
      return false;
    return true;
  };
  function Companion_6() {
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ProductTypeImportedEvent', this, 2);
    tmp0_serialDesc.ht('item', false);
    tmp0_serialDesc.ht('time', false);
    this.m2j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).ii = function () {
    return this.m2j_1;
  };
  protoOf($serializer_5).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_11(), LongSerializer_getInstance()];
  };
  protoOf($serializer_5).ki = function (decoder) {
    var tmp0_desc = this.m2j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return ProductTypeImportedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_5).n2j = function (encoder, value) {
    var tmp0_desc = this.m2j_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_11(), value.o2j_1);
    tmp1_output.fn(tmp0_desc, 1, value.p2j_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_5).ji = function (encoder, value) {
    return this.n2j(encoder, value instanceof ProductTypeImportedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_5;
  function $serializer_getInstance_8() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function ProductTypeImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_8().m2j_1);
    }
    $this.o2j_1 = item;
    $this.p2j_1 = time;
    return $this;
  }
  function ProductTypeImportedEvent_init_$Create$(seen1, item, time, serializationConstructorMarker) {
    return ProductTypeImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, objectCreate(protoOf(ProductTypeImportedEvent)));
  }
  function ProductTypeImportedEvent(item, time) {
    this.o2j_1 = item;
    this.p2j_1 = time;
  }
  protoOf(ProductTypeImportedEvent).q20 = function () {
    return this.o2j_1;
  };
  protoOf(ProductTypeImportedEvent).g2c = function () {
    return this.p2j_1;
  };
  protoOf(ProductTypeImportedEvent).s2Id = function () {
    return this.o2j_1.q2j_1;
  };
  protoOf(ProductTypeImportedEvent).toString = function () {
    return 'ProductTypeImportedEvent(item=' + this.o2j_1 + ', time=' + this.p2j_1.toString() + ')';
  };
  protoOf(ProductTypeImportedEvent).hashCode = function () {
    var result = this.o2j_1.hashCode();
    result = imul(result, 31) + this.p2j_1.hashCode() | 0;
    return result;
  };
  protoOf(ProductTypeImportedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductTypeImportedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ProductTypeImportedEvent ? other : THROW_CCE();
    if (!this.o2j_1.equals(tmp0_other_with_cast.o2j_1))
      return false;
    if (!this.p2j_1.equals(tmp0_other_with_cast.p2j_1))
      return false;
    return true;
  };
  function ProductTypeUpdateCommandDTO() {
  }
  function ProductTypeUpdatedEventDTO() {
  }
  function Companion_7() {
    Companion_instance_7 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z2j_1 = [null, null, null, new ArrayListSerializer($serializer_init_$Create$(StringSerializer_getInstance())), new ArrayListSerializer($serializer_init_$Create$(StringSerializer_getInstance())), null];
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    if (Companion_instance_7 == null)
      new Companion_7();
    return Companion_instance_7;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.productType.domain.command.ProductTypeUpdateCommand', this, 6);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('organizationTypes', false);
    tmp0_serialDesc.ht('ouvrageTypes', false);
    tmp0_serialDesc.ht('total', false);
    this.a2k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).ii = function () {
    return this.a2k_1;
  };
  protoOf($serializer_6).wt = function () {
    var tmp0_cached = Companion_getInstance_7().z2j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3]), get_nullable(tmp0_cached[4]), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_6).ki = function (decoder) {
    var tmp0_desc = this.a2k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.ul(tmp0_desc);
    var tmp11_cached = Companion_getInstance_7().z2j_1;
    if (tmp10_input.km()) {
      tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.im(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.im(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.im(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.im(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.im(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.im(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.vl(tmp0_desc);
    return ProductTypeUpdateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_6).b2k = function (encoder, value) {
    var tmp0_desc = this.a2k_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_7().z2j_1;
    tmp1_output.jn(tmp0_desc, 0, value.c2k_1);
    tmp1_output.jn(tmp0_desc, 1, value.d2k_1);
    tmp1_output.nn(tmp0_desc, 2, StringSerializer_getInstance(), value.e2k_1);
    tmp1_output.nn(tmp0_desc, 3, tmp2_cached[3], value.f2k_1);
    tmp1_output.nn(tmp0_desc, 4, tmp2_cached[4], value.g2k_1);
    tmp1_output.nn(tmp0_desc, 5, LongSerializer_getInstance(), value.h2k_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_6).ji = function (encoder, value) {
    return this.b2k(encoder, value instanceof ProductTypeUpdateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_6;
  function $serializer_getInstance_9() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function ProductTypeUpdateCommand_init_$Init$(seen1, id, name, img, organizationTypes, ouvrageTypes, total, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen1))) {
      throwMissingFieldException(seen1, 63, $serializer_getInstance_9().a2k_1);
    }
    $this.c2k_1 = id;
    $this.d2k_1 = name;
    $this.e2k_1 = img;
    $this.f2k_1 = organizationTypes;
    $this.g2k_1 = ouvrageTypes;
    $this.h2k_1 = total;
    return $this;
  }
  function ProductTypeUpdateCommand_init_$Create$(seen1, id, name, img, organizationTypes, ouvrageTypes, total, serializationConstructorMarker) {
    return ProductTypeUpdateCommand_init_$Init$(seen1, id, name, img, organizationTypes, ouvrageTypes, total, serializationConstructorMarker, objectCreate(protoOf(ProductTypeUpdateCommand)));
  }
  function ProductTypeUpdateCommand(id, name, img, organizationTypes, ouvrageTypes, total) {
    Companion_getInstance_7();
    this.c2k_1 = id;
    this.d2k_1 = name;
    this.e2k_1 = img;
    this.f2k_1 = organizationTypes;
    this.g2k_1 = ouvrageTypes;
    this.h2k_1 = total;
  }
  protoOf(ProductTypeUpdateCommand).k1y = function () {
    return this.c2k_1;
  };
  protoOf(ProductTypeUpdateCommand).h9 = function () {
    return this.d2k_1;
  };
  protoOf(ProductTypeUpdateCommand).d2d = function () {
    return this.e2k_1;
  };
  protoOf(ProductTypeUpdateCommand).i2i = function () {
    return this.f2k_1;
  };
  protoOf(ProductTypeUpdateCommand).j2i = function () {
    return this.g2k_1;
  };
  protoOf(ProductTypeUpdateCommand).i1z = function () {
    return this.h2k_1;
  };
  protoOf(ProductTypeUpdateCommand).toString = function () {
    return 'ProductTypeUpdateCommand(id=' + this.c2k_1 + ', name=' + this.d2k_1 + ', img=' + this.e2k_1 + ', organizationTypes=' + this.f2k_1 + ', ouvrageTypes=' + this.g2k_1 + ', total=' + toString(this.h2k_1) + ')';
  };
  protoOf(ProductTypeUpdateCommand).hashCode = function () {
    var result = getStringHashCode(this.c2k_1);
    result = imul(result, 31) + getStringHashCode(this.d2k_1) | 0;
    result = imul(result, 31) + (this.e2k_1 == null ? 0 : getStringHashCode(this.e2k_1)) | 0;
    result = imul(result, 31) + (this.f2k_1 == null ? 0 : hashCode(this.f2k_1)) | 0;
    result = imul(result, 31) + (this.g2k_1 == null ? 0 : hashCode(this.g2k_1)) | 0;
    result = imul(result, 31) + (this.h2k_1 == null ? 0 : this.h2k_1.hashCode()) | 0;
    return result;
  };
  protoOf(ProductTypeUpdateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductTypeUpdateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ProductTypeUpdateCommand ? other : THROW_CCE();
    if (!(this.c2k_1 === tmp0_other_with_cast.c2k_1))
      return false;
    if (!(this.d2k_1 === tmp0_other_with_cast.d2k_1))
      return false;
    if (!(this.e2k_1 == tmp0_other_with_cast.e2k_1))
      return false;
    if (!equals(this.f2k_1, tmp0_other_with_cast.f2k_1))
      return false;
    if (!equals(this.g2k_1, tmp0_other_with_cast.g2k_1))
      return false;
    if (!equals(this.h2k_1, tmp0_other_with_cast.h2k_1))
      return false;
    return true;
  };
  function Companion_8() {
    Companion_instance_8 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i2k_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance()), new ArrayListSerializer($serializer_getInstance_0()), null, null];
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    if (Companion_instance_8 == null)
      new Companion_8();
    return Companion_instance_8;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ProductTypeUpdatedEvent', this, 7);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('organizationTypes', false);
    tmp0_serialDesc.ht('ouvrageTypes', false);
    tmp0_serialDesc.ht('total', false);
    tmp0_serialDesc.ht('time', false);
    this.j2k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ii = function () {
    return this.j2k_1;
  };
  protoOf($serializer_7).wt = function () {
    var tmp0_cached = Companion_getInstance_8().i2k_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance_1()), tmp0_cached[3], tmp0_cached[4], get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_7).ki = function (decoder) {
    var tmp0_desc = this.j2k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.ul(tmp0_desc);
    var tmp12_cached = Companion_getInstance_8().i2k_1;
    if (tmp11_input.km()) {
      tmp4_local0 = tmp11_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.im(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.gm(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.gm(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.im(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.im(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.im(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.gm(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.gm(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.im(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.im(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.vl(tmp0_desc);
    return ProductTypeUpdatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_7).k2k = function (encoder, value) {
    var tmp0_desc = this.j2k_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_8().i2k_1;
    tmp1_output.jn(tmp0_desc, 0, value.l2k_1);
    tmp1_output.jn(tmp0_desc, 1, value.m2k_1);
    tmp1_output.nn(tmp0_desc, 2, $serializer_getInstance_1(), value.n2k_1);
    tmp1_output.ln(tmp0_desc, 3, tmp2_cached[3], value.o2k_1);
    tmp1_output.ln(tmp0_desc, 4, tmp2_cached[4], value.p2k_1);
    tmp1_output.nn(tmp0_desc, 5, LongSerializer_getInstance(), value.q2k_1);
    tmp1_output.nn(tmp0_desc, 6, LongSerializer_getInstance(), value.r2k_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_7).ji = function (encoder, value) {
    return this.k2k(encoder, value instanceof ProductTypeUpdatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_7;
  function $serializer_getInstance_10() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function ProductTypeUpdatedEvent_init_$Init$(seen1, id, name, img, organizationTypes, ouvrageTypes, total, time, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen1))) {
      throwMissingFieldException(seen1, 127, $serializer_getInstance_10().j2k_1);
    }
    $this.l2k_1 = id;
    $this.m2k_1 = name;
    $this.n2k_1 = img;
    $this.o2k_1 = organizationTypes;
    $this.p2k_1 = ouvrageTypes;
    $this.q2k_1 = total;
    $this.r2k_1 = time;
    return $this;
  }
  function ProductTypeUpdatedEvent_init_$Create$(seen1, id, name, img, organizationTypes, ouvrageTypes, total, time, serializationConstructorMarker) {
    return ProductTypeUpdatedEvent_init_$Init$(seen1, id, name, img, organizationTypes, ouvrageTypes, total, time, serializationConstructorMarker, objectCreate(protoOf(ProductTypeUpdatedEvent)));
  }
  function ProductTypeUpdatedEvent(id, name, img, organizationTypes, ouvrageTypes, total, time) {
    Companion_getInstance_8();
    this.l2k_1 = id;
    this.m2k_1 = name;
    this.n2k_1 = img;
    this.o2k_1 = organizationTypes;
    this.p2k_1 = ouvrageTypes;
    this.q2k_1 = total;
    this.r2k_1 = time;
  }
  protoOf(ProductTypeUpdatedEvent).k1y = function () {
    return this.l2k_1;
  };
  protoOf(ProductTypeUpdatedEvent).h9 = function () {
    return this.m2k_1;
  };
  protoOf(ProductTypeUpdatedEvent).d2d = function () {
    return this.n2k_1;
  };
  protoOf(ProductTypeUpdatedEvent).i2i = function () {
    return this.o2k_1;
  };
  protoOf(ProductTypeUpdatedEvent).j2i = function () {
    return this.p2k_1;
  };
  protoOf(ProductTypeUpdatedEvent).i1z = function () {
    return this.q2k_1;
  };
  protoOf(ProductTypeUpdatedEvent).g2c = function () {
    return this.r2k_1;
  };
  protoOf(ProductTypeUpdatedEvent).s2Id = function () {
    return this.l2k_1;
  };
  protoOf(ProductTypeUpdatedEvent).toString = function () {
    return 'ProductTypeUpdatedEvent(id=' + this.l2k_1 + ', name=' + this.m2k_1 + ', img=' + this.n2k_1 + ', organizationTypes=' + this.o2k_1 + ', ouvrageTypes=' + this.p2k_1 + ', total=' + toString(this.q2k_1) + ', time=' + toString(this.r2k_1) + ')';
  };
  protoOf(ProductTypeUpdatedEvent).hashCode = function () {
    var result = getStringHashCode(this.l2k_1);
    result = imul(result, 31) + getStringHashCode(this.m2k_1) | 0;
    result = imul(result, 31) + (this.n2k_1 == null ? 0 : this.n2k_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.o2k_1) | 0;
    result = imul(result, 31) + hashCode(this.p2k_1) | 0;
    result = imul(result, 31) + (this.q2k_1 == null ? 0 : this.q2k_1.hashCode()) | 0;
    result = imul(result, 31) + (this.r2k_1 == null ? 0 : this.r2k_1.hashCode()) | 0;
    return result;
  };
  protoOf(ProductTypeUpdatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductTypeUpdatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ProductTypeUpdatedEvent ? other : THROW_CCE();
    if (!(this.l2k_1 === tmp0_other_with_cast.l2k_1))
      return false;
    if (!(this.m2k_1 === tmp0_other_with_cast.m2k_1))
      return false;
    if (!equals(this.n2k_1, tmp0_other_with_cast.n2k_1))
      return false;
    if (!equals(this.o2k_1, tmp0_other_with_cast.o2k_1))
      return false;
    if (!equals(this.p2k_1, tmp0_other_with_cast.p2k_1))
      return false;
    if (!equals(this.q2k_1, tmp0_other_with_cast.q2k_1))
      return false;
    if (!equals(this.r2k_1, tmp0_other_with_cast.r2k_1))
      return false;
    return true;
  };
  function ProductTypeModelDTO() {
  }
  function Companion_9() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s2k_1 = [null, Companion_getInstance().x14(), null, null, new ArrayListSerializer($serializer_getInstance()), new ArrayListSerializer($serializer_getInstance_0()), null, null, null];
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.productType.domain.model.ProductTypeModel', this, 9);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('organizationTypes', false);
    tmp0_serialDesc.ht('ouvrageTypes', false);
    tmp0_serialDesc.ht('total', false);
    tmp0_serialDesc.ht('creationDate', false);
    tmp0_serialDesc.ht('updatedDate', false);
    this.t2k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).ii = function () {
    return this.t2k_1;
  };
  protoOf($serializer_8).wt = function () {
    var tmp0_cached = Companion_getInstance_9().s2k_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], StringSerializer_getInstance(), get_nullable($serializer_getInstance_1()), tmp0_cached[4], tmp0_cached[5], get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_8).ki = function (decoder) {
    var tmp0_desc = this.t2k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.ul(tmp0_desc);
    var tmp14_cached = Companion_getInstance_9().s2k_1;
    if (tmp13_input.km()) {
      tmp4_local0 = tmp13_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.gm(tmp0_desc, 1, tmp14_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.im(tmp0_desc, 3, $serializer_getInstance_1(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.gm(tmp0_desc, 4, tmp14_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.gm(tmp0_desc, 5, tmp14_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.im(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.im(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.im(tmp0_desc, 8, LongSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.gm(tmp0_desc, 1, tmp14_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.im(tmp0_desc, 3, $serializer_getInstance_1(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.gm(tmp0_desc, 4, tmp14_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.gm(tmp0_desc, 5, tmp14_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.im(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.im(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.im(tmp0_desc, 8, LongSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.vl(tmp0_desc);
    return ProductTypeModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_8).u2k = function (encoder, value) {
    var tmp0_desc = this.t2k_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_9().s2k_1;
    tmp1_output.jn(tmp0_desc, 0, value.q2j_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.r2j_1);
    tmp1_output.jn(tmp0_desc, 2, value.s2j_1);
    tmp1_output.nn(tmp0_desc, 3, $serializer_getInstance_1(), value.t2j_1);
    tmp1_output.ln(tmp0_desc, 4, tmp2_cached[4], value.u2j_1);
    tmp1_output.ln(tmp0_desc, 5, tmp2_cached[5], value.v2j_1);
    tmp1_output.nn(tmp0_desc, 6, LongSerializer_getInstance(), value.w2j_1);
    tmp1_output.nn(tmp0_desc, 7, LongSerializer_getInstance(), value.x2j_1);
    tmp1_output.nn(tmp0_desc, 8, LongSerializer_getInstance(), value.y2j_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_8).ji = function (encoder, value) {
    return this.u2k(encoder, value instanceof ProductTypeModel ? value : THROW_CCE());
  };
  var $serializer_instance_8;
  function $serializer_getInstance_11() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function ProductTypeModel_init_$Init$(seen1, id, status, name, img, organizationTypes, ouvrageTypes, total, creationDate, updatedDate, serializationConstructorMarker, $this) {
    if (!(511 === (511 & seen1))) {
      throwMissingFieldException(seen1, 511, $serializer_getInstance_11().t2k_1);
    }
    $this.q2j_1 = id;
    $this.r2j_1 = status;
    $this.s2j_1 = name;
    $this.t2j_1 = img;
    $this.u2j_1 = organizationTypes;
    $this.v2j_1 = ouvrageTypes;
    $this.w2j_1 = total;
    $this.x2j_1 = creationDate;
    $this.y2j_1 = updatedDate;
    return $this;
  }
  function ProductTypeModel_init_$Create$(seen1, id, status, name, img, organizationTypes, ouvrageTypes, total, creationDate, updatedDate, serializationConstructorMarker) {
    return ProductTypeModel_init_$Init$(seen1, id, status, name, img, organizationTypes, ouvrageTypes, total, creationDate, updatedDate, serializationConstructorMarker, objectCreate(protoOf(ProductTypeModel)));
  }
  function ProductTypeModel() {
  }
  protoOf(ProductTypeModel).k1y = function () {
    return this.q2j_1;
  };
  protoOf(ProductTypeModel).y2f = function () {
    return this.r2j_1;
  };
  protoOf(ProductTypeModel).h9 = function () {
    return this.s2j_1;
  };
  protoOf(ProductTypeModel).d2d = function () {
    return this.t2j_1;
  };
  protoOf(ProductTypeModel).i2i = function () {
    return this.u2j_1;
  };
  protoOf(ProductTypeModel).j2i = function () {
    return this.v2j_1;
  };
  protoOf(ProductTypeModel).i1z = function () {
    return this.w2j_1;
  };
  protoOf(ProductTypeModel).v2h = function () {
    return this.x2j_1;
  };
  protoOf(ProductTypeModel).w2h = function () {
    return this.y2j_1;
  };
  protoOf(ProductTypeModel).s2State = function () {
    return this.r2j_1;
  };
  protoOf(ProductTypeModel).s2Id = function () {
    return this.q2j_1;
  };
  protoOf(ProductTypeModel).toString = function () {
    return 'ProductTypeModel(id=' + this.q2j_1 + ', status=' + this.r2j_1 + ', name=' + this.s2j_1 + ', img=' + this.t2j_1 + ', organizationTypes=' + this.u2j_1 + ', ouvrageTypes=' + this.v2j_1 + ', total=' + toString(this.w2j_1) + ', creationDate=' + toString(this.x2j_1) + ', updatedDate=' + toString(this.y2j_1) + ')';
  };
  protoOf(ProductTypeModel).hashCode = function () {
    var result = getStringHashCode(this.q2j_1);
    result = imul(result, 31) + this.r2j_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.s2j_1) | 0;
    result = imul(result, 31) + (this.t2j_1 == null ? 0 : this.t2j_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.u2j_1) | 0;
    result = imul(result, 31) + hashCode(this.v2j_1) | 0;
    result = imul(result, 31) + (this.w2j_1 == null ? 0 : this.w2j_1.hashCode()) | 0;
    result = imul(result, 31) + (this.x2j_1 == null ? 0 : this.x2j_1.hashCode()) | 0;
    result = imul(result, 31) + (this.y2j_1 == null ? 0 : this.y2j_1.hashCode()) | 0;
    return result;
  };
  protoOf(ProductTypeModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductTypeModel))
      return false;
    var tmp0_other_with_cast = other instanceof ProductTypeModel ? other : THROW_CCE();
    if (!(this.q2j_1 === tmp0_other_with_cast.q2j_1))
      return false;
    if (!this.r2j_1.equals(tmp0_other_with_cast.r2j_1))
      return false;
    if (!(this.s2j_1 === tmp0_other_with_cast.s2j_1))
      return false;
    if (!equals(this.t2j_1, tmp0_other_with_cast.t2j_1))
      return false;
    if (!equals(this.u2j_1, tmp0_other_with_cast.u2j_1))
      return false;
    if (!equals(this.v2j_1, tmp0_other_with_cast.v2j_1))
      return false;
    if (!equals(this.w2j_1, tmp0_other_with_cast.w2j_1))
      return false;
    if (!equals(this.x2j_1, tmp0_other_with_cast.x2j_1))
      return false;
    if (!equals(this.y2j_1, tmp0_other_with_cast.y2j_1))
      return false;
    return true;
  };
  function ProductTypePolicies() {
  }
  protoOf(ProductTypePolicies).canPage = function (authedUser) {
    return true;
  };
  protoOf(ProductTypePolicies).canGet = function (authedUser) {
    return true;
  };
  protoOf(ProductTypePolicies).canCreate = function (authedUser) {
    return hasRole(authedUser, 'Marque');
  };
  protoOf(ProductTypePolicies).canUpdate = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().e2i_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(ProductTypeUpdateCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.productType.domain.policy.ProductTypePolicies.canUpdate.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ProductTypePolicies).canDelete = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().e2i_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(ProductTypeDeleteCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.productType.domain.policy.ProductTypePolicies.canDelete.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  var ProductTypePolicies_instance;
  function ProductTypePolicies_getInstance() {
    return ProductTypePolicies_instance;
  }
  function ProductTypeGetQueryDTO() {
  }
  function ProductTypeGetResponseDTO() {
  }
  function ProductTypePageQueryFiltersDTO() {
  }
  function ProductTypePageQueryDTO() {
  }
  function ProductTypePageResponseDTO() {
  }
  //region block: post-declaration
  defineProp(protoOf(ProductTypeState), 'position', function () {
    return this.jr();
  }, function (value) {
    this.y2c(value);
  });
  defineProp(protoOf(ProductTypeState), 'name', protoOf(ProductTypeState).h9);
  defineProp(protoOf(ProductTypeState), 'ordinal', protoOf(ProductTypeState).i9);
  protoOf($serializer).xt = typeParametersSerializers;
  protoOf($serializer_0).xt = typeParametersSerializers;
  defineProp(protoOf(ProductTypeCreateCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(ProductTypeCreateCommand), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(ProductTypeCreateCommand), 'organizationTypes', function () {
    return this.i2i();
  });
  defineProp(protoOf(ProductTypeCreateCommand), 'ouvrageTypes', function () {
    return this.j2i();
  });
  defineProp(protoOf(ProductTypeCreateCommand), 'total', function () {
    return this.i1z();
  });
  protoOf($serializer_1).xt = typeParametersSerializers;
  defineProp(protoOf(ProductTypeCreatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductTypeCreatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(ProductTypeCreatedEvent), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(ProductTypeCreatedEvent), 'organizationTypes', function () {
    return this.i2i();
  });
  defineProp(protoOf(ProductTypeCreatedEvent), 'ouvrageTypes', function () {
    return this.j2i();
  });
  defineProp(protoOf(ProductTypeCreatedEvent), 'total', function () {
    return this.i1z();
  });
  defineProp(protoOf(ProductTypeCreatedEvent), 'time');
  protoOf($serializer_2).xt = typeParametersSerializers;
  defineProp(protoOf(ProductTypeDeleteCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_3).xt = typeParametersSerializers;
  defineProp(protoOf(ProductTypeDeletedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductTypeDeletedEvent), 'time');
  protoOf($serializer_4).xt = typeParametersSerializers;
  defineProp(protoOf(ProductTypeImportCommand), 'item', function () {
    return this.q20();
  });
  protoOf($serializer_5).xt = typeParametersSerializers;
  defineProp(protoOf(ProductTypeImportedEvent), 'item', function () {
    return this.q20();
  });
  defineProp(protoOf(ProductTypeImportedEvent), 'time');
  protoOf($serializer_6).xt = typeParametersSerializers;
  defineProp(protoOf(ProductTypeUpdateCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductTypeUpdateCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(ProductTypeUpdateCommand), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(ProductTypeUpdateCommand), 'organizationTypes', function () {
    return this.i2i();
  });
  defineProp(protoOf(ProductTypeUpdateCommand), 'ouvrageTypes', function () {
    return this.j2i();
  });
  defineProp(protoOf(ProductTypeUpdateCommand), 'total', function () {
    return this.i1z();
  });
  protoOf($serializer_7).xt = typeParametersSerializers;
  defineProp(protoOf(ProductTypeUpdatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductTypeUpdatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(ProductTypeUpdatedEvent), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(ProductTypeUpdatedEvent), 'organizationTypes', function () {
    return this.i2i();
  });
  defineProp(protoOf(ProductTypeUpdatedEvent), 'ouvrageTypes', function () {
    return this.j2i();
  });
  defineProp(protoOf(ProductTypeUpdatedEvent), 'total', function () {
    return this.i1z();
  });
  defineProp(protoOf(ProductTypeUpdatedEvent), 'time');
  protoOf($serializer_8).xt = typeParametersSerializers;
  defineProp(protoOf(ProductTypeModel), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ProductTypeModel), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(ProductTypeModel), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(ProductTypeModel), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(ProductTypeModel), 'organizationTypes', function () {
    return this.i2i();
  });
  defineProp(protoOf(ProductTypeModel), 'ouvrageTypes', function () {
    return this.j2i();
  });
  defineProp(protoOf(ProductTypeModel), 'total', function () {
    return this.i1z();
  });
  defineProp(protoOf(ProductTypeModel), 'creationDate', function () {
    return this.v2h();
  });
  defineProp(protoOf(ProductTypeModel), 'updatedDate', function () {
    return this.w2h();
  });
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_3 = new Companion_3();
  Companion_instance_4 = new Companion_4();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  ProductTypePolicies_instance = new ProductTypePolicies();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$productType = $org$boislocal$platform$s2.productType || ($org$boislocal$platform$s2.productType = {});
    var $org$boislocal$platform$s2$productType$domain = $org$boislocal$platform$s2$productType.domain || ($org$boislocal$platform$s2$productType.domain = {});
    var $org$boislocal$platform$s2$productType$domain$automate = $org$boislocal$platform$s2$productType$domain.automate || ($org$boislocal$platform$s2$productType$domain.automate = {});
    $org$boislocal$platform$s2$productType$domain$automate.ProductTypeState = ProductTypeState;
    $org$boislocal$platform$s2$productType$domain$automate.ProductTypeState.values = values;
    $org$boislocal$platform$s2$productType$domain$automate.ProductTypeState.valueOf = valueOf;
    defineProp($org$boislocal$platform$s2$productType$domain$automate.ProductTypeState, 'Exists', ProductTypeState_Exists_getInstance);
    defineProp($org$boislocal$platform$s2$productType$domain$automate.ProductTypeState, 'Deleted', ProductTypeState_Deleted_getInstance);
    defineProp($org$boislocal$platform$s2$productType$domain$automate.ProductTypeState, 'Companion', Companion_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$productType = $org$boislocal$platform$s2.productType || ($org$boislocal$platform$s2.productType = {});
    var $org$boislocal$platform$s2$productType$domain = $org$boislocal$platform$s2$productType.domain || ($org$boislocal$platform$s2$productType.domain = {});
    var $org$boislocal$platform$s2$productType$domain$command = $org$boislocal$platform$s2$productType$domain.command || ($org$boislocal$platform$s2$productType$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$productType = $org$boislocal$platform$s2.productType || ($org$boislocal$platform$s2.productType = {});
    var $org$boislocal$platform$s2$productType$domain = $org$boislocal$platform$s2$productType.domain || ($org$boislocal$platform$s2$productType.domain = {});
    var $org$boislocal$platform$s2$productType$domain$command = $org$boislocal$platform$s2$productType$domain.command || ($org$boislocal$platform$s2$productType$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$productType = $org$boislocal$platform$s2.productType || ($org$boislocal$platform$s2.productType = {});
    var $org$boislocal$platform$s2$productType$domain = $org$boislocal$platform$s2$productType.domain || ($org$boislocal$platform$s2$productType.domain = {});
    var $org$boislocal$platform$s2$productType$domain$command = $org$boislocal$platform$s2$productType$domain.command || ($org$boislocal$platform$s2$productType$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$productType = $org$boislocal$platform$s2.productType || ($org$boislocal$platform$s2.productType = {});
    var $org$boislocal$platform$s2$productType$domain = $org$boislocal$platform$s2$productType.domain || ($org$boislocal$platform$s2$productType.domain = {});
    var $org$boislocal$platform$s2$productType$domain$command = $org$boislocal$platform$s2$productType$domain.command || ($org$boislocal$platform$s2$productType$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$productType = $org$boislocal$platform$s2.productType || ($org$boislocal$platform$s2.productType = {});
    var $org$boislocal$platform$s2$productType$domain = $org$boislocal$platform$s2$productType.domain || ($org$boislocal$platform$s2$productType.domain = {});
    var $org$boislocal$platform$s2$productType$domain$model = $org$boislocal$platform$s2$productType$domain.model || ($org$boislocal$platform$s2$productType$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$productType = $org$boislocal$platform$s2.productType || ($org$boislocal$platform$s2.productType = {});
    var $org$boislocal$platform$s2$productType$domain = $org$boislocal$platform$s2$productType.domain || ($org$boislocal$platform$s2$productType.domain = {});
    var $org$boislocal$platform$s2$productType$domain$policy = $org$boislocal$platform$s2$productType$domain.policy || ($org$boislocal$platform$s2$productType$domain.policy = {});
    defineProp($org$boislocal$platform$s2$productType$domain$policy, 'ProductTypePolicies', ProductTypePolicies_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$productType = $org$boislocal$platform$s2.productType || ($org$boislocal$platform$s2.productType = {});
    var $org$boislocal$platform$s2$productType$domain = $org$boislocal$platform$s2$productType.domain || ($org$boislocal$platform$s2$productType.domain = {});
    var $org$boislocal$platform$s2$productType$domain$query = $org$boislocal$platform$s2$productType$domain.query || ($org$boislocal$platform$s2$productType$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$productType = $org$boislocal$platform$s2.productType || ($org$boislocal$platform$s2.productType = {});
    var $org$boislocal$platform$s2$productType$domain = $org$boislocal$platform$s2$productType.domain || ($org$boislocal$platform$s2$productType.domain = {});
    var $org$boislocal$platform$s2$productType$domain$query = $org$boislocal$platform$s2$productType$domain.query || ($org$boislocal$platform$s2$productType$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-s2-referential-productType-productType-domain.js.map
